import * as T from '../../../../../components/Typography';
import * as S from '../style';
import { Icon } from '../../../../../components';
import MDEditor from '../../../../../components/MDEditor';
import theme from '../../../../../theme';

const OneQuestionPerRowMultipleInputsSection = ({
  section,
  i,
  onPreChange,
  removeCorrectOptions,
  validationErrs,
  optionsLength,
}) => {
  return (
    <div
      style={{
        background: i % 2 ? 'white' : theme.colors.neutralLight,
        border: `1px solid ${theme.colors.neutral50}`,
        marginTop: '40px',
      }}
    >
      <T.P mb={2} mt={5} weight="bold" size="med">
        Section {i + 1}
      </T.P>
      <>
        <MDEditor
          label="Question text"
          value={section[0].pre}
          onChange={(value) => {
            onPreChange(value, i, 0);
          }}
          height={80}
          m={{ mb: 2, mt: 5 }}
          error={!section[0]?.pre && validationErrs?.options?.[0]?.[i]?.pre}
          helper="Wrap text with {{}} to mark where students will input their answers, e.g '240 + {{60}} = 300'"
        />
      </>

      {optionsLength === 1 && i === 0 ? null : (
        <S.Button
          type="link"
          danger
          ghost
          mt={1}
          onClick={() => removeCorrectOptions(i)}
          ml="auto"
        >
          <Icon icon="cross" />
        </S.Button>
      )}
    </div>
  );
};

export default OneQuestionPerRowMultipleInputsSection;
